//
// Copyright (C) 2021 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/VehiclePropertyStatus.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file android/hardware/automotive/vehicle/VehiclePropertyStatus.proto.
 */
export const file_android_hardware_automotive_vehicle_VehiclePropertyStatus: GenFile = /*@__PURE__*/
  fileDesc("Cj9hbmRyb2lkL2hhcmR3YXJlL2F1dG9tb3RpdmUvdmVoaWNsZS9WZWhpY2xlUHJvcGVydHlTdGF0dXMucHJvdG8SKWFuZHJvaWQuaGFyZHdhcmUuYXV0b21vdGl2ZS52ZWhpY2xlLnByb3RvKkIKFVZlaGljbGVQcm9wZXJ0eVN0YXR1cxINCglBVkFJTEFCTEUQABIPCgtVTkFWQUlMQUJMRRABEgkKBUVSUk9SEAJiBnByb3RvMw");

/**
 * Must be in sync with VehiclePropertyStatus.aidl. 
 *
 * @generated from enum android.hardware.automotive.vehicle.proto.VehiclePropertyStatus
 */
export enum VehiclePropertyStatus {
  /**
   * Property is available and behaving normally 
   *
   * @generated from enum value: AVAILABLE = 0;
   */
  AVAILABLE = 0,

  /**
   * A property in this state is not available for reading and writing.  This
   * is a transient state that depends on the availability of the underlying
   * implementation (e.g. hardware or driver). It MUST NOT be used to
   * represent features that this vehicle is always incapable of.  A get() of
   * a property in this state MAY return an undefined value, but MUST
   * correctly describe its status as UNAVAILABLE A set() of a property in
   * this state MAY return NOT_AVAILABLE. The HAL implementation MUST ignore
   * the value of the status field when writing a property value coming from
   * Android. 
   *
   * @generated from enum value: UNAVAILABLE = 1;
   */
  UNAVAILABLE = 1,

  /**
   * There is an error with this property. 
   *
   * @generated from enum value: ERROR = 2;
   */
  ERROR = 2,
}

/**
 * Describes the enum android.hardware.automotive.vehicle.proto.VehiclePropertyStatus.
 */
export const VehiclePropertyStatusSchema: GenEnum<VehiclePropertyStatus> = /*@__PURE__*/
  enumDesc(file_android_hardware_automotive_vehicle_VehiclePropertyStatus, 0);

